<div class="spacing-top">
	<div data-testid="SUBSYS4_BONE_SELECTION_CANCEL_BTN" class="wrapper-back" (click)="back()" (keypress)="back()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ labels().BONE_TYPE_SELECTION_COMPONENT_CANCEL_BTN }}</span>
	</div>
</div>

<div class="main-step">
	<div class="box-menu-settings active">
		<div class="row-box">
			<h4>{{ labels().BONE_TYPE_SELECTION_COMPONENT_TITLE }}</h4>
		</div>
		<div class="row-box">
			<div class="box-suggestion">
				<p>{{ labels().BONE_TYPE_SELECTION_COMPONENT_MESSAGE }}</p>
			</div>
		</div>
		<div class="row-box bones-area">


			@if (isLeft) {
			<div class="bones-wrapper right pt-0">

				<div class="right-side">

					<div class="custom-control custom-radio custom-control-inline bones-item">
						<input type="radio" id="longleg-left" name="boneTypeLeft" class="custom-control-input"
							[value]="boneTypeEnum.LongLeg" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="longleg-left">
							{{ boneTypeEnum.LongLeg | boneTypeLabel | uppercase }}
						</label>
					</div>

					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="femur-left" name="boneTypeLeft" class="custom-control-input"
							[value]="boneTypeEnum.Femur" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="femur-left" aria-label="femur left"></label>
					</div>

					<div class="bones-divider"></div>

					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="tibia-left" name="boneTypeLeft" class="custom-control-input"
							[value]="boneTypeEnum.Tibia" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="tibia-left" aria-label="tibia left"></label>
					</div>

				</div>
				<label class="info-leg-bottom" for="info-left" aria-label="info left">
					{{ boneType | boneTypeLabel }}
				</label>
			</div>
			}

			@if (isRight) {
			<div class="bones-wrapper left pt-0">
				<div class="left-side">

					<div class="custom-control custom-radio custom-control-inline bones-item">
						<input type="radio" id="longleg-right" name="boneTypeRight" class="custom-control-input"
							[value]="boneTypeEnum.LongLeg" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="longleg-right">
							{{ boneTypeEnum.LongLeg | boneTypeLabel | uppercase }}</label>
					</div>

					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="femur-right" name="boneTypeRight" class="custom-control-input"
							[value]="boneTypeEnum.Femur" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="femur-right" aria-label="femur right"></label>
					</div>

					<div class="bones-divider"></div>

					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="tibia-right" name="boneTypeRight" class="custom-control-input"
							[value]="boneTypeEnum.Tibia" [(ngModel)]="boneType" />
						<label class="custom-control-label" for="tibia-right" aria-label="tibia right"></label>
					</div>

				</div>
				<label class="info-leg-bottom" for="info-right" aria-label="info right">
					{{ boneType | boneTypeLabel }}
				</label>
			</div>
			}

		</div>
		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS4_BONE_SELECTION_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					[disabled]="!boneType" (click)="confirm()">
					{{ labels().BONE_TYPE_SELECTION_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>
	</div>
</div>